import {action, Action} from 'easy-peasy';

interface ViewTypeFieldChoice {
    id: number;
    name: string;
    value: string;
}

interface EvaluationTypeChoice {
    id: number;
    name: string;
    value: string;
}

interface ViewTypeFieldChoicesStore {
    items: ViewTypeFieldChoice[];
    loadViewTypeFieldChoices: Action<ViewTypeFieldChoicesStore, ViewTypeFieldChoice[]>;
    evaluationTypeChoices: EvaluationTypeChoice[];
    loadEvaluationTypeChoices: Action<ViewTypeFieldChoicesStore, EvaluationTypeChoice[]>;
}

const viewTypeFieldChoices: ViewTypeFieldChoicesStore = {
    items: [],
    loadViewTypeFieldChoices: action((state, viewTypeFieldChoicesList) => {
        state.items = viewTypeFieldChoicesList;
    }),
    evaluationTypeChoices: [],
    loadEvaluationTypeChoices: action((state, evaluationTypeChoicesList) => {
        state.evaluationTypeChoices = evaluationTypeChoicesList;
    }),
};

export default viewTypeFieldChoices;
